import Select from "../../../../form/select/Select";

const TextAlignOptions = ({ editor }) => {
  const alignmentOptions = [
    { name: "Left Align", value: "left", icon: "format align-left" },
    { name: "Center Align", value: "center", icon: "format align-center" },
    { name: "Right Align", value: "right", icon: "format align-right" },
    { name: "Justify Align", value: "justify", icon: "format align-justify" },
  ];

  function getActiveAlignment() {
    return (
      ["left", "center", "right", "justify"].find((alignment) =>
        editor.isActive({ textAlign: alignment })
      ) || "left"
    );
  }

  function onChangeHandler(val) {
    editor.chain().focus().setTextAlign(val).run();
  }

  return (
    <div className="w-36">
      <Select
        dropdownData={alignmentOptions}
        selectedValue={getActiveAlignment()}
        onChange={onChangeHandler}
        checked={false}
        dropdownButtonClass={"!h-9 !text-xs !font-medium"}
      />
    </div>
  );
};

export default TextAlignOptions;
